export default "__VITE_ASSET__DkK$HrpJ__"